var React = require('react');

function Office365Light (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.367.223a2 2 0 011.364-.076l12.846 3.874A2 2 0 0144 5.936v36.128a2 2 0 01-1.423 1.915l-12.864 3.88a2 2 0 01-1.3-.051l-23.775-9.22A1 1 0 014 37.657V11.962a2 2 0 011.214-1.839l23.153-9.9zM42 5.936L29.154 2.062 6 11.962V36.05l6.271-3.088v-20.05a2 2 0 011.488-1.934l13.823-3.663a2 2 0 012.513 1.933v30.386a2 2 0 01-2.257 1.984l-14.79-1.912 16.087 6.238L42 42.064V5.936zM8.415 37.089l19.68 2.544V9.247L14.27 12.91v20.051a2 2 0 01-1.116 1.794l-4.74 2.334z"}));
}

Office365Light.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Office365Light;

Office365Light.default = Office365Light;
